import React, {Component} from "react";
import {Container, Row, Col, Card, CardBody, Button, Alert} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone,} from "react-bootstrap-table2-paginator";
import ToolkitProvider, {Search,} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import NewModal from "./NewModal";
import DeleteModal from "./DeleteModal";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {withTranslation} from "react-i18next";
import PropTypes from "prop-types";
import {companiesExport, companiesExportAccounts, companiesImport, companiesImportAccounts, companiesList} from "../../store/companies/actions";
import {connect} from "react-redux";
import AnalyticalAccountsModal from "./AnalyticalAccounts";
import GraphModal from "../../components/Common/GraphModal";
import {apiGetCompaniesGraph} from "../../api/calls/companies";

class Companies extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companiesData: [],
      loadingList: false,
      errorList: "",
      loadingImport: false,
      messageImport: "",
      errorImport: "",
      loadingImportAccounts: false,
      messageImportAccounts: "",
      errorImportAccounts: "",
      companyData: null,
      newModal: false,
      deleteModal: false,
      analyticalAccountModal: false,
      graphModal: false,
      actualCompany: "",
    }
    this.togNew = this.togNew.bind(this)
    this.togDelete = this.togDelete.bind(this)
    this.togAnalyticalAccounts = this.togAnalyticalAccounts.bind(this)
    this.togGraph = this.togGraph.bind(this)
    this.companiesImport = this.companiesImport.bind(this)
    this.companiesExport = this.companiesExport.bind(this)
    this.confirmCompaniesImport = this.confirmCompaniesImport.bind(this)
    this.accountsImport = this.accountsImport.bind(this)
    this.accountsExport = this.accountsExport.bind(this)
    this.confirmAccountsImport = this.confirmAccountsImport.bind(this)

    this.importCompanies = React.createRef()
    this.importAccounts = React.createRef()
  }

  componentDidMount() {
    this.props.onCompaniesList({history: this.props.history});
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        companiesData: this.props.responseList ? this.props.responseList.response : [],
        loadingList: this.props.loadingList,
        errorList: this.props.errorList,
        loadingImport: this.props.loadingImport,
        messageImport: this.props.messageImport,
        errorImport: this.props.errorImport,
        loadingImportAccounts: this.props.loadingImportAccounts,
        messageImportAccounts: this.props.messageImportAccounts,
        errorImportAccounts: this.props.errorImportAccounts,
      });

      if (!prevProps.loadingImport && this.props.loadingImport) {
        this.props.onCompaniesList({history: this.props.history});
      }
    }
  }

  togNew(data = null, action) {
    this.setState(prevState => ({
      action: action,
      companyData: data,
      newModal: !prevState.newModal,
    }))
  }

  togDelete(data = null) {
    this.setState(prevState => ({
      companyData: data,
      deleteModal: !prevState.deleteModal,
    }))
  }

  togAnalyticalAccounts(data = null) {
    this.setState(prevState => ({
      companyData: data,
      analyticalAccountModal: !prevState.analyticalAccountModal,
    }))
  }

  togGraph(data = null) {
    this.setState(prevState => ({
      actualCompany: data ? data.actualCompany : "",
      graphData: data ? data.data : null,
      graphModal: !prevState.graphModal,
    }))
  }

  companiesExport() {
    this.props.onCompaniesExport({history: this.props.history})
  }

  companiesImport() {
    this.importCompanies.current.click();
  }

  confirmCompaniesImport(e) {
    const formData = new FormData()
    formData.append('file', e.target.files[0])
    this.props.onCompaniesImport({file: formData, history: this.props.history})
  }

  accountsExport() {
    this.props.onCompaniesExportAccounts({history: this.props.history})
  }

  accountsImport() {
    this.importAccounts.current.click();
  }

  confirmAccountsImport(e) {
    const formData = new FormData()
    formData.append('file', e.target.files[0])
    this.props.onCompaniesImportAccounts({file: formData, history: this.props.history})
  }

  render() {
    const actionFormatter = (cell, row) => {
      return (<div>
        <Button color="info" className="me-2 mb-2" onClick={() => this.togAnalyticalAccounts({id: row.id, name: row.name})}>Analytical Accounts</Button>
        <Button color="warning" className="me-2 mb-2" onClick={() => this.togGraph({data: {id: row.id}, actualCompany: row.name})}>Graph</Button>
        <Button color="success" className="me-2 mb-2" onClick={() => this.togNew({id: row.id, name: row.name, crn: row.crn, tax_id: row.tax_id, vat_id: row.vat_id}, "edit")}>Edit</Button>
        <Button color="danger" className="me-2 mb-2" onClick={() => this.togDelete({id: row.id, name: row.name})}>Delete</Button>
      </div>);
    }

    const columns = [{
      dataField: "id", text: "Id", sort: true,
    }, {
      dataField: "name", text: "Name", sort: true,
    }, {
      dataField: "crn", text: "Crn", sort: true,
    }, {
      dataField: "tax_id", text: "Tax Id", sort: true,
    }, {
      dataField: "vat_id", text: "Vat Id", sort: true,
    }, {
      dataField: "created", text: "Created", sort: true,
    }, {
      dataField: "", text: "Actions", sort: true, formatter: actionFormatter,
    },];

    const defaultSorted = [{
      dataField: "id", order: "asc",
    },];

    const pageOptions = {
      sizePerPage: 10, totalSize: this.state.companiesData.length, custom: true, sizePerPageList: [{
        text: '10', value: 10
      }, {
        text: '25', value: 25
      }, {
        text: '50', value: 50
      }]
    };

    const {SearchBar} = Search;

    function onColumnMatch({searchText, value, column, row}) {
      if ((row.name && row.name.toLowerCase().includes(searchText)) || row.crn.toLowerCase().includes(searchText)
        || (row.tax_id && row.tax_id.toLowerCase().includes(searchText)) || (row.vat_id && row.vat_id.toLowerCase().includes(searchText))
        || row.created.includes(searchText))
        return true
      return false
    }

    document.title = "Companies | FileJet";

    return (<React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={this.props.t("FileJet")} breadcrumbItem={this.props.t("Companies")}/>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="id"
                    columns={columns}
                    data={this.state.companiesData}
                  >
                    {({paginationProps, paginationTableProps}) => (<ToolkitProvider
                      keyField="id"
                      columns={columns}
                      data={this.state.companiesData}
                      search={{onColumnMatch}}
                    >
                      {toolkitProps => (<React.Fragment>
                        <Row className="mb-2">
                          <Col md="8">
                            <div>
                              <Button color="primary" className="me-2 mb-2" onClick={() => this.togNew({}, "new")}>
                                New
                              </Button>
                              <Button color="primary" className="me-2 mb-2" onClick={this.companiesExport}>
                                Export Companies
                              </Button>
                              <Button color="primary" className="me-2 mb-2" onClick={this.companiesImport}>
                                Import Companies
                              </Button>
                              <Button color="primary" className="me-2 mb-2" onClick={this.accountsExport}>
                                Export Accounts
                              </Button>
                              <Button color="primary" className="me-2 mb-2" onClick={this.accountsImport}>
                                Import Accounts
                              </Button>
                              <input type='file' id='importCompanies' ref={this.importCompanies} style={{display: 'none'}} onChange={(e) => this.confirmCompaniesImport(e)}/>
                              <input type='file' id='importAccounts' ref={this.importAccounts} style={{display: 'none'}} onChange={(e) => this.confirmAccountsImport(e)}/>
                            </div>
                          </Col>
                          <Col md="4">
                            <div className="search-box me-2 mb-2 d-inline-block float-end">
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} placeholder="Filter"/>
                                <i className="bx bx-search-alt search-icon"/>
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col xl="12">
                            <div className="table-responsive">
                              <BootstrapTable
                                keyField={"id"}
                                responsive
                                bordered={false}
                                striped={false}
                                defaultSorted={defaultSorted}
                                classes={"table align-middle table-nowrap"}
                                headerWrapperClasses={"thead-light"}
                                {...toolkitProps.baseProps}
                                {...paginationTableProps}
                              />
                            </div>
                          </Col>
                        </Row>

                        <Row className="align-items-md-center mt-30">
                          <Col className="inner-custom-pagination d-flex">
                            <div className="d-inline">
                              <SizePerPageDropdownStandalone {...paginationProps}/>
                            </div>
                            <div className="text-md-right ms-auto">
                              <PaginationListStandalone {...paginationProps}/>
                            </div>
                          </Col>
                        </Row>
                      </React.Fragment>)}
                    </ToolkitProvider>)}
                  </PaginationProvider>
                  {(this.state.loadingList || this.state.loadingImport || this.state.loadingImportAccounts) && (<div className="d-flex justify-content-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>)}
                  {this.state.messageImport.length > 0 && (<div className="mt-3"><Alert color="info" role="alert">{this.state.messageImport}</Alert></div>)}
                  {this.state.messageImportAccounts.length > 0 && (<div className="mt-3"><Alert color="info" role="alert">{this.state.messageImportAccounts}</Alert></div>)}
                  {this.state.errorList.length > 0 && (<div className="mt-3"><Alert color="danger" role="alert">{this.state.errorList}</Alert></div>)}
                  {this.state.errorImport.length > 0 && (<div className="mt-3"><Alert color="danger" role="alert">{this.state.errorImport}</Alert></div>)}
                  {this.state.errorImportAccounts.length > 0 && (<div className="mt-3"><Alert color="danger" role="alert">{this.state.errorImportAccounts}</Alert></div>)}
                </CardBody>
              </Card>
            </Col>
          </Row>
          {this.state.newModal &&
            <NewModal action={this.state.action} togModal={this.togNew} refreshParent={this.props.onCompaniesList} companyData={this.state.companyData} history={this.props.history}/>}
          {this.state.deleteModal && <DeleteModal togModal={this.togDelete} refreshParent={this.props.onCompaniesList} companyData={this.state.companyData} history={this.props.history}/>}
          {this.state.analyticalAccountModal && <AnalyticalAccountsModal togModal={this.togAnalyticalAccounts} companyData={this.state.companyData} history={this.props.history}/>}
          {this.state.graphModal && <GraphModal togModal={this.togGraph} call={apiGetCompaniesGraph} actionData={this.state.graphData} title={this.state.actualCompany} history={this.props.history}/>}
        </Container>
      </div>
    </React.Fragment>);
  }
}

Companies.propTypes = {
  responseList: PropTypes.any,
  onCompaniesList: PropTypes.func,
  onCompaniesExport: PropTypes.func,
  onCompaniesImport: PropTypes.func,
  onCompaniesExportAccounts: PropTypes.func,
  onCompaniesImportAccounts: PropTypes.func,
};

const mapStateToProps = ({Companies}) => ({
  responseList: Companies.responseList,
  loadingList: Companies.loadingList,
  errorList: Companies.errorList,
  loadingImport: Companies.loadingImport,
  messageImport: Companies.messageImport,
  errorImport: Companies.errorImport,
  loadingImportAccounts: Companies.loadingImportAccounts,
  messageImportAccounts: Companies.messageImportAccounts,
  errorImportAccounts: Companies.errorImportAccounts,
});

const mapDispatchToProps = dispatch => ({
  onCompaniesList: data => dispatch(companiesList(data)),
  onCompaniesExport: data => dispatch(companiesExport(data)),
  onCompaniesImport: data => dispatch(companiesImport(data)),
  onCompaniesExportAccounts: data => dispatch(companiesExportAccounts(data)),
  onCompaniesImportAccounts: data => dispatch(companiesImportAccounts(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Companies));
